import { BaseApiClient } from '../base-api-client';
export class LeaderboardClient extends BaseApiClient {
    constructor(config) {
        const fullConfig = {
            ...config,
            baseURL: `${config.baseURL}/leaderboard`,
        };
        super(fullConfig, 'LeaderboardClient');
    }
    async getLeaderboard(limit = 100) {
        try {
            const response = await this.get(`/leaderboard?limit=${limit}`);
            if (!response.success) {
                throw new Error(response.error || 'Failed to get leaderboard');
            }
            return response.data || [];
        }
        catch (error) {
            console.error('[LeaderboardClient] Error getting leaderboard:', this.truncateError(error));
            throw error;
        }
    }
    async getUserStats(userId) {
        try {
            const response = await this.get(`/stats/${userId}`);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to get user stats');
            }
            return response.data;
        }
        catch (error) {
            console.error('[LeaderboardClient] Error getting user stats:', this.truncateError(error));
            throw error;
        }
    }
    async getUserRank(userId) {
        try {
            const response = await this.get(`/rank/${userId}`);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to get user rank');
            }
            return response.data.rank;
        }
        catch (error) {
            console.error('[LeaderboardClient] Error getting user rank:', this.truncateError(error));
            throw error;
        }
    }
    async completeEvent(params) {
        try {
            const response = await this.post('/complete-event', params);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to complete event');
            }
            return response.data;
        }
        catch (error) {
            console.error('[LeaderboardClient] Error completing event:', this.truncateError(error));
            throw error;
        }
    }
    async getActiveEvents() {
        try {
            const response = await this.get('/events');
            if (!response.success) {
                throw new Error(response.error || 'Failed to get active events');
            }
            return response.data || [];
        }
        catch (error) {
            console.error('[LeaderboardClient] Error getting active events:', this.truncateError(error));
            throw error;
        }
    }
    async getUserEvents(userId) {
        try {
            const response = await this.get(`/events/${userId}`);
            if (!response.success) {
                throw new Error(response.error || 'Failed to get user events');
            }
            return response.data || [];
        }
        catch (error) {
            console.error('[LeaderboardClient] Error getting user events:', this.truncateError(error));
            throw error;
        }
    }
}
//# sourceMappingURL=leaderboard-client.js.map